import { graphql } from "gatsby"
import React from "react"

import { IntersectionObserver } from "@atoms/IntersectionObserver/IntersectionObserver"
import Combo from "@molecules/Combo/Combo"

const Combo5050 = ({ blockDataComboVideo }) => {
  const { variant, heading, text, video, quoted, links } =
    blockDataComboVideo || {}
  const { mediaItemUrl } = video || {}

  return mediaItemUrl ? (
    <section className="section-break-out section-capped-width make-full-width-on-mobile global-combo">
      <IntersectionObserver reset={true}>
        <Combo
          variant={variant}
          title={heading}
          text={text}
          videoUrl={mediaItemUrl}
          quoted={quoted}
          links={links}
        />
      </IntersectionObserver>
    </section>
  ) : (
    ""
  )
}

export const query = graphql`
  fragment ComboVideo on WpBlockAcfComboVideo {
    __typename
    blockDataComboVideo {
      variant
      heading
      text
      quoted
      video {
        id
        mediaItemUrl
      }
      links {
        link {
          url
          title
          target
        }
      }
    }
  }
`

export default Combo5050
